/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as onboarding from './onboarding-flow';
import * as retention from './retention-flow';

export const ampTrack = {
  onboarding,
  retention,
};

export * from './user-property-store';
export * from './parse-amp-properties';
